// Per-user, per-project settings stored in ProjectUserSettings.settings.
// Each top-level key is an independent preference; unknown keys are preserved
// on update so future preferences can be added without migrations.

/** statusByType key for tasks with no task type assigned. */
export const UNTYPED_TASK_TYPE_KEY = 'none'

export interface TimerAutoStatusSettings {
  /** Off by default; the auto-move only fires when explicitly enabled. */
  enabled: boolean
  /** taskTypeDefId (or UNTYPED_TASK_TYPE_KEY) -> target status slug. Types
   * without an entry are left untouched when a timer starts. */
  statusByType: Record<string, string>
}

export interface ProjectUserSettingsData {
  timerAutoStatus?: TimerAutoStatusSettings
}
